import { UserAddressAdapter, Address } from '@spartacus/core';
import { Observable } from 'rxjs';

export abstract class CustomUserAddressAdapter extends UserAddressAdapter {
  abstract loadAllByZone(userId: string, zone?: string): Observable<Address[]>;
}
